module.exports = __webpack_public_path__ + "img/banner.486aec5.png";